/**
 * Query keys factory for Progress Tracker Settings
 * Provides consistent query key generation for caching and invalidation
 */
export const progressTrackerQueryKeys = {
  all: ['ProgressTracker'] as const,
  settings: (entityId: number) => [...progressTrackerQueryKeys.all, 'settings', entityId] as const,
  list: () => [...progressTrackerQueryKeys.all, 'list'] as const,
} as const;

export type ProgressTrackerQueryKeys = typeof progressTrackerQueryKeys;
